import { render } from "./ObjectivesSection.vue?vue&type=template&id=990baede&scoped=true"
import script from "./ObjectivesSection.vue?vue&type=script&lang=js"
export * from "./ObjectivesSection.vue?vue&type=script&lang=js"

import "./ObjectivesSection.vue?vue&type=style&index=0&id=990baede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990baede"]])

export default __exports__